import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchWorkspaceAuditLogs } from '@/api/audit/auditApi';
import type { AuditLogEntry, AuditLogQuery } from '@/api/audit/auditApi.types';
import type { PaginatedResult } from '@/api/pagination.types';
import { WORKSPACE_AUDIT_LOGS_QUERY_KEY } from '@/constants/queryKeys';

export function useWorkspaceAuditLogsQuery(
  query: AuditLogQuery,
  isEnabled: boolean
): UseQueryResult<PaginatedResult<AuditLogEntry>, Error> {
  return useQuery({
    queryKey: [...WORKSPACE_AUDIT_LOGS_QUERY_KEY, query],
    queryFn: function loadWorkspaceAuditLogs() {
      return fetchWorkspaceAuditLogs(query);
    },
    enabled: isEnabled,
    placeholderData: keepPreviousData,
  });
}
